import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema, FetchResponse } from "./ApiClient";

export type LinkItemDataType = Partial<ApiSchema["LinkItem"]["type"]>;

function normalizeExternalUrl(url: string): string {
    const trimmed = url.trim();
    if (!trimmed) return trimmed;
    if (/^https?:\/\//i.test(trimmed)) {
        return trimmed;
    }
    return `https://${trimmed}`;
}

class Api extends GenericModelApi<"LinkItem", LinkItemDataType> {
    override async create(input: LinkItemDataType): Promise<LinkItemDataType> {
        const url = typeof input.url === "string" ? normalizeExternalUrl(input.url) : input.url;
        return super.create({ ...input, url });
    }

    override async update(id: string, input: Partial<Omit<LinkItemDataType, "id">>, allowNulls = false): Promise<LinkItemDataType> {
        const next: Partial<Omit<LinkItemDataType, "id">> = { ...input };
        if (typeof input.url === "string") {
            next.url = normalizeExternalUrl(input.url);
        }
        return super.update(id, next, allowNulls);
    }

    /** Lista por tenant y filtra por categoría (sin GSI ni relación GraphQL LinkCategory ↔ LinkItem). */
    async fetchAllByCategoryId(linkCategoryId: string): Promise<FetchResponse<LinkItemDataType>> {
        return this.fetchAll({ linkCategoryId: { eq: linkCategoryId } }, "", 5000);
    }
}

export const LinkItemApi = new Api("LinkItem", "title", "ASC");
